export const potashPrices = {
    title: 'Potash Prices',
    type: 'POTASH_PRICES',
    navigation: {
        type: 'GraphViews',
        nav: [
            {
                title: 'c',
                graph: {
                    colNames: ['', 'Region', 'Q1A', 'Q2F', 'Q3F', 'Q4F'],
                    data: {
                        rows: [
                            {
                                title: 'Brazil',
                                data: [751, 785, 791, 794],
                                kmt: [173, 49, 85, 40]
                            },
                            {
                                title: 'China',
                                data: [509, 500, 500, 500],
                                kmt: [173, 49, 85, 40]
                            },
                            {
                                title: 'India',
                                data: [675, 531, 433, 435],
                                kmt: [675, 49, 85, 40]
                            },
                            {
                                title: 'USA',
                                data: [424, 500, 500, 500],
                                kmt: [173, 49, 85, 40]
                            },
                            {
                                title: 'Europe',
                                data: [712, 600, 600, 550],
                                kmt: [173, 49, 85, 40]
                            },
                            {
                                title: 'Mediterrain',
                                data: [658, 661, 667, 668],
                                kmt: [173, 49, 85, 40]
                            },
                        ],
                        total: {
                            title: 'Total',
                            data: [641, 625, 614, 688],
                            kmt: [173, 49, 85, 40]
                        }
                    }
                }
            }
        ]
    }
}
